import {FC, useEffect, useRef} from "react";
import Box, {BoxProps} from "@mui/material/Box";

export type SizeObservableBoxProps = BoxProps & {
    onSizeChange: (width: number, height: number) => void
}

const SizeObservableBox: FC<SizeObservableBoxProps> = ({onSizeChange, ...rest}) => {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const updateWidth = () => {
            if (ref.current) {
                onSizeChange(ref.current!.offsetWidth, ref.current!.offsetHeight);
            }
        };
        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, [onSizeChange]);

    return (
        <Box ref={ref} {...rest} />
    )
}

export default SizeObservableBox
